import React from 'react';
import { inject, observer } from 'mobx-react';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import type { ThreadAction } from '@stores/thread/action';
import PC from './layout/pc';
import H5 from './layout/h5';
import { BasePage } from '@components/Base/BasePage';
import styles from './index.module.scss';
import type { BasePageProps } from '../../types/base';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router-dom';
import type { BasePageState } from '../../types/base';
import { applyDefaultSEO } from '@utils/seo';


interface HomeProps extends BasePageProps, RouteComponentProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    thread?: ThreadAction;
}
interface HomeState extends BasePageState {
    myValue: string;
}
@inject('app', 'site', 'user', 'thread')
@observer
class home extends BasePage<HomeProps> {
    namespace='threadList';
    state: HomeState = {
        loading: false,
        error: null,
        pageLoaded: false,
        myValue: ''
    };
    componentDidMount() {
        applyDefaultSEO();
        const { app, user, thread } = this.props;
        if (thread) {
            let params: any = {
                "page[number]": 1,
                "page[size]": 20
            }
            thread.getThreadList(params)
        }
        super.componentDidMount();
    }

    // 跳转到话题详情页
    handleTopicClick = (id: string | number) => {
        this.props.history && this.props.history.push(`/topicDetail/${id}`);
    };

    // 只获取数据，不渲染
    getThreadListData = () => {
        const { thread } = this.props;
        if (!thread || !thread.listStore) return [];
        const list = thread.listStore.lists[this.namespace];
        if (!list) return [];
        return thread.listStore.getList({ namespace: this.namespace });
    }

    // 加载更多
    handleLoadMore = () => {
        const { thread } = this.props;
        if (!thread || !thread.listStore) return;
        
        const list = thread.listStore.lists[this.namespace];
        if (!list || list.loading || !list.hasMore) {
            // console.log('[Home] 跳过加载:', { 
            //     hasStore: !!list, 
            //     loading: list?.loading, 
            //     hasMore: list?.hasMore 
            // });
            return;
        }

        // 优先使用 attribs.currentPage，其次使用 attribs.page，最后默认为 1
        const currentPage = list.attribs?.currentPage || list.attribs?.page || 1;
        const nextPage = currentPage + 1;
        const params = {
            "page[number]": nextPage,
            "page[size]": 20
        };
        
        console.log('[Home] 开始加载下一页:', { currentPage, nextPage, params });
        thread.getThreadList(params);
    }

    render() {
        const { app, thread, user } = this.props;
        const platform = app?.platform || 'h5';
        // 获取列表数据和状态
        const namespace = this.namespace;
        const listStore = thread?.listStore;
        const list = listStore?.lists[namespace];
        const threadList = listStore?.getList({ namespace }) || [];
        const loading = list?.loading || false;
        const hasMore = list?.hasMore ?? true;
        
        // 如果平台信息还未初始化，显示加载状态
        if (!app?.platform) {
            return (
                <div className={styles.loading} style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh'
                }}>
                    <div>加载中...</div>
                </div>
            );
        } else {
            return (
                <div className={platform === 'pc' ? styles.pcWrap : styles.h5Wrap}>
                    {platform === 'pc' ? (
                        <PC
                            threadList={threadList}
                            loading={loading}
                            hasMore={hasMore}
                            onLoadMore={this.handleLoadMore}
                            userInfo={user}
                        />
                    ) : (
                        <H5
                            threadList={threadList}
                            loading={loading}
                            hasMore={hasMore}
                            onLoadMore={this.handleLoadMore}
                            userInfo={user}
                        />
                    )}
                    {platform === 'pc' && <div className={styles.footer} style={{fontSize: '12px', lineHeight: '16px', padding: '20px 0',}}>
                        <span>@广东天宸网络科技有限公司&nbsp;版权所有</span>
                        <span className={styles.footerGap} style={{margin: '0 12px', width: '1px', height: '8px'}}></span>
                        <span style={{cursor: 'pointer', color: '#002A8D'}} onClick={()=> {
                            this.props.history && this.props.history.push(`/privacy`);
                        }}>隐私政策</span>
                        <span className={styles.footerGap} style={{margin: '0 12px', width: '1px', height: '8px'}}></span>
                        <span style={{cursor: 'pointer', color: '#002A8D'}} onClick={()=> {
                            this.props.history && this.props.history.push(`/selfDiscipline`);
                        }}>用户协议</span>
                        <span className={styles.footerGap} style={{margin: '0 12px', width: '1px', height: '8px'}}></span>
                        <a style={{color: '#002A8D'}} href=' https://beian.mps.gov.cn/#/query/webSearch'>粤ICP备14052990号-2</a>
                        <span className={styles.footerGap} style={{margin: '0 12px', width: '1px', height: '8px'}}></span>
                        <a style={{color: '#002A8D'}} href='https://beian.mps.gov.cn/#/query/webSearch'>粤公网安备44190002004246号</a>
                        
                    </div>}
                    {/* {platform === 'h5' && <div className={styles.footer} style={{fontSize: '14px', lineHeight: '30px'}}>
                        <span>@广东天宸网络科技有限公司&nbsp;&nbsp;&nbsp;版权所有</span>
                        <br />
                        <span style={{cursor: 'pointer'}} onClick={()=> {
                            this.props.history && this.props.history.push(`/privacy`);
                        }}>隐私政策</span>
                        <span style={{cursor: 'pointer'}} onClick={()=> {
                            this.props.history && this.props.history.push(`/selfDiscipline`);
                        }}>&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;用户协议</span>
                        <br />
                        <a href=' https://beian.mps.gov.cn/#/query/webSearch'>粤ICP备14052990号-2</a>&nbsp;|&nbsp;
                       
                        <a href='https://beian.mps.gov.cn/#/query/webSearch'>粤公网安备44190002004246号</a>
                        
                    </div>} */}
                </div>
            )
        }

    }
}

export default withRouter(home);
